import { Role } from "./role";
import { Country } from "./country";

 
export class User  {
  userID: string;
  name: string;
role: Role = new Role();
country: Country = new Country();
  password: string = "";
  confirmPassword: string = "";
  blocked: boolean;
  disabled: boolean;
  hash: string = "";
  logUser: string = "";
  userFile: string;
  employeeID: number;
  editMode: boolean;
}
